module.exports = __webpack_public_path__ + "img/Ayjc.47b8bd36.svg";